<div
    class="footnote-box-section"
    *ngIf="(disableClaimAccount$ | async) === false || (disableClaimAccount$ | async) === undefined"
>
    <div class="footnote-box-header">
        <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
            {{ moduleAuthTexts.footnote_message ? moduleAuthTexts.footnote_message :'Have you booked via phone/chat?' }}
        </span>
        <!-- <div class="tooltip-holder" *ngIf="claimAccountSettings.description">
            <span class="tooltip-icon obf-icon icon-si-info-circle"></span>
            <div class="tooltip-description" [innerHTML]="claimAccountSettings.description"></div>
        </div> -->
    </div>
    <div class="claim-account-link">
        <span class="cursor" (click)="onChangeScreen('claim-account')" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
            {{ moduleAuthTexts.claim_your_account_label ? moduleAuthTexts.claim_your_account_label :'Claim your account' }}
        </span>
    </div>
</div>